import { render, staticRenderFns } from "./HeaderDeAditivos.vue?vue&type=template&id=7cad6455&scoped=true"
import script from "./HeaderDeAditivos.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDeAditivos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDeAditivos.vue?vue&type=style&index=0&id=7cad6455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cad6455",
  null
  
)

export default component.exports